import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "components/Button";
import { Row, Col } from "react-bootstrap";

import {
  iconAmex,
  iconVisa,
  iconDiners,
  iconEftposAu,
  iconUnionpay,
  iconMastercard,
  iconJcb,
} from "assets/icons";
import { MailIcon, PlanCardContainer } from "./PlanCard.styles";
import { parseErrorMessage } from "utils";
import { userDetailSelect } from "Layout/slice/selector";
import { toast } from "Layout/slice";
import { NewPurchaseCard } from "shared/PurchasePlanCard/NewPurchaseCard.jsx";
import { Loader } from "components/Loader";
import { updatePaymentMethod } from "features/Account/v2/PurchasePlan/service";
import { openNewTab } from "utils";
import { isFreeUser } from "utils/index";

const PlanCard = () => {
  const dispatch = useDispatch();
  const userDetails = useSelector(userDetailSelect);

  const [isFetching, setIsFetching] = useState(false);
  const [showPurchasePlanModal, setShowPurchasePlanModal] = useState("");

  const stripeSubscription = userDetails?.stripe_subscription;
  const defaultPayment = stripeSubscription?.default_payment_method;

  const brandIcons = {
    visa: iconVisa,
    amex: iconAmex,
    diners: iconDiners,
    eftpos_au: iconEftposAu,
    jcb: iconJcb,
    mastercard: iconMastercard,
    unionpay: iconUnionpay,
  };
  const isActivePlan =
    userDetails?.stripe_subscription === null ||
    (userDetails?.stripe_subscription &&
      userDetails?.stripe_subscription?.cancel_at === null);
  const isFreePlan = isFreeUser();

  useEffect(() => {
    if (isActivePlan && !isFreePlan) {
      setShowPurchasePlanModal("CANCEL_PLAN");
    }
  }, [isFreePlan, isActivePlan]);

  const handleUpdateClick = async () => {
    setIsFetching(true);
    try {
      const { url } = await updatePaymentMethod();
      openNewTab(url, "_self");
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <PlanCardContainer>
      <Row className="w-100 plan-card-row">
        <Col lg={7} md={12} className="main-card">
          <div className="card-container premium">
            <NewPurchaseCard
              isAccountPage={true}
              isChangePlan={showPurchasePlanModal == "CHANGE_PLAN"}
              isCancelPlan={showPurchasePlanModal == "CANCEL_PLAN"}
            />
          </div>
        </Col>

        <Col>
          {defaultPayment && (
            <div className="payment-method-container">
              <div className="header">
                <h1 className="title">Payment method</h1>
              </div>

              <div className="plan-card-information">
                <div className="default-payment-card">
                  <div className="card-wrapper">
                    {brandIcons[defaultPayment?.card?.brand] && (
                      <div className="icon">
                        <img src={brandIcons[defaultPayment?.card?.brand]} />
                      </div>
                    )}

                    <div className="card-details">
                      <div className="ending">
                        <span className="brand">
                          {defaultPayment?.card?.brand}
                        </span>{" "}
                        **** **** ****-{defaultPayment?.card?.last4 || "xxxx"}
                      </div>

                      <div className="date">
                        Expires:{" "}
                        {`${defaultPayment?.card?.exp_month}/${defaultPayment?.card?.exp_year}` ||
                          "xx/xxxx"}
                      </div>

                      <div className="email-wrapper">
                        <MailIcon />
                        <span className="date">
                          {defaultPayment?.billing_details?.email}
                        </span>
                      </div>
                    </div>
                  </div>

                  <Button
                    variant="secondary"
                    size="small"
                    onClick={handleUpdateClick}
                  >
                    Update
                    {isFetching && <Loader className="on-btn" />}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Col>
      </Row>
    </PlanCardContainer>
  );
};

PlanCard.propTypes = {
  plan: PropTypes.object,
};

export default PlanCard;
